import axios from 'axios';

import AuthService from '../services/auth.service';
import { toast } from 'react-toastify'
import authHeader from './auth-header';
import CommonService from './common.service';
import configData from "../config.json";

const API_URL = `${configData.API_URL}/note`;

class NoteService {
    deleteNote(id) {
        return AuthService.getFreshToken().then(access_token => {
            let url = `${API_URL}?id=${id}`;
            return axios.delete(url, { headers: { Authorization: `Bearer ${access_token}` }}).then(response => {
                return response.data;
            },
            error => {
                return CommonService.handleError(error, 'setNotes');
            });
        })
    }
    setNote(note) {
        return AuthService.getFreshToken().then(access_token => {
            let url = `${API_URL}/store`;
            return axios.post(url, note, { blocking: true, headers: { Authorization: `Bearer ${access_token}` }}).then(response => {
                // toast.success(`Erfolgreich gespeichert`, {autoClose:1500})
                return response.data;
            },
            error => {
                return CommonService.handleError(error, 'setNotes');
            });
        })
    }
}

export default new NoteService();
